import React from "react";
import Particles from "react-tsparticles";
import roni from '../pic/roni.png'
// import { FaReact, FaNode } from 'react-icons/fa';
// import ParticlesBackground from "./ParticlesBackground";
// import { loadFull } from "tsparticles";
// import ParticlesBackground from "./ParticlesBackground";


const About = () => {
    const particlesInit = (main) => {
        console.log(main);
    };

    const particlesLoaded = (container) => {
        console.log(container);
    };
    return (
        <section id="about">
            <Particles
                id="tsparticles"
                init={particlesInit}
                loaded={particlesLoaded}
                options={{

                    fpsLimit: 60,
                    interactivity: {
                        events: {
                            onClick: {
                                enable: true,
                                mode: "push",
                            },
                            onHover: {
                                enable: true,
                                mode: "repulse",
                            },
                            resize: true,
                        },
                        modes: {
                            bubble: {
                                distance: 400,
                                duration: 2,
                                opacity: 0.8,
                                size: 40
                            },
                            push: {
                                quantity: 4,
                            },
                            repulse: {
                                distance: 200,
                                duration: 0.4,
                            },
                        },
                    },
                    particles: {
                        color: {
                            value: "#ffffff",
                        },
                        links: {
                            color: "#ffffff",
                            distance: 150,
                            enable: true,
                            opacity: 0.5,
                            width: 1,
                        },
                        collisions: {
                            enable: true,
                        },
                        move: {
                            direction: "none",
                            enable: true,
                            outModes: {
                                default: "bounce",
                            },
                            random: false,
                            speed: 6,
                            straight: false,
                        },
                        number: {
                            density: {
                                enable: true,
                                area: 800,
                            },
                            value: 80,
                        },
                        opacity: {
                            value: 0.5,
                        },
                        shape: {
                            type: "circle",
                        },
                        size: {
                            value: { min: 1, max: 5 },
                        },
                    },
                    detectRetina: true,
                }}
            />
            <div className="drop-shadow-xl">
                <div className='pt-20 px-10 grid grid-cols-1 lg:grid-cols-3 gap-2 items-center bg-slate-900 text-white'>
                    <div>
                        <h1 className='text-white font-serif text-5xl py-5 first-line:uppercase first-line:tracking-widest
                   first-letter:text-8xl first-letter:font-bold first-letter:text-yellow-300
                  first-letter:mr-3 first-letter:float-left'>RAHUL DAHR RONI</h1>
                        <div className="flex my-1 flex-wrap">
                            <img src="https://img.shields.io/badge/JavaScript-F7DF1E?style=for-the-badge&logo=javascript&logoColor=black" alt="" className="rounded m-1 w-24" />
                            <img src="https://img.shields.io/badge/React-20232A?style=for-the-badge&logo=react&logoColor=61DAFB" alt=""
                                className="rounded m-1 w-24" />
                            <img src="https://img.shields.io/badge/MongoDB-4EA94B?style=for-the-badge&logo=mongodb&logoColor=white" alt=""
                                className="rounded m-1 w-24" />
                            <img src="https://img.shields.io/badge/Express.js-404D59?style=for-the-badge" alt="" className="rounded m-1 w-24" />
                            <img src="https://img.shields.io/badge/Node.js-43853D?style=for-the-badge&logo=node.js&logoColor=white" alt="" className="rounded m-1 w-24" />

                        </div>
                    </div>
                    <div className='bg-slate-700 rounded-full items-end justify-center overflow-hidden shadow-orange-50 drop-shadow-xl' data-aos="fade-up">
                        <img src={roni} alt="" className="w-96 justify-center" />
                    </div>
                    <div className='p-5'>
                        <h1 className='text-red-500'>INTRODUCTION</h1>
                        <h1 className='text-white font-serif text-3xl py-5'>WEB DEVELOPER | WORDPRESS DEVELOPER| GRAPHIC DESIGNER</h1>
                        <p>I am a positive enthusiastic and creative Web developer who over the years, has build up a diverse rang of skills, qualities and attributes. I have been working as a full stake web developer and WordPress developer for last 3 years around.
                        </p>
                        <button class="btn btn-outline btn-warning my-2"><a className="" href='https://drive.google.com/file/d/1iKzoMX0Vjlmu8s3Vf7OSlgBQK1moVOsA/view?usp=sharing' download>Resume</a></button>
                    </div>
                </div>

            </div >
        </section>
    );
}

export default About;